<template>
  <div :class="[customTagClass ? `tag-item-${customTagClass}` : 'tag-item']">
    <slot v-if="textTag" />
    <NuxtLink v-if="linkTag" :to="link">{{ text }}</NuxtLink>
    <button
      type="button"
      class="tag-delete-btn"
      @click="handleSearchItemDelete"
    ></button>
  </div>
</template>
<script lang="ts" setup>
defineProps({
  link: String,
  text: String,
  customTagClass: String,
  linkTag: Boolean,
  textTag: Boolean
});

const emit = defineEmits(['delete'])

// tag 아이템 클릭
const handleSearchItemDelete = () => {
  emit('delete')
  // const searchItemButtons = document.querySelectorAll(".tag-delete-btn");
  // searchItemButtons.forEach(function(button) {
  //   button.addEventListener("click", function () {
  //     const searchItem = button.closest(".tag-li") as HTMLElement;
  //     searchItem.remove();
  //   });
  // });
};
</script>
<style lang="scss" scoped>
</style>
